module.exports = __webpack_public_path__ + "static/media/so.c17ecf2a.svg";